<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { FormDefinition, FormResponse, FormResponseStatus } from "~/api";
import FormRendererInner from "~/NewFormBuilder/components/Renderer/FormRendererInner.vue";
import { FormDisplayMode } from "~/NewFormBuilder/types/FormDisplayMode";
import { useMyInfoStore } from "~/stores/MyInfoStore";
import { apiClient } from "~/utils/apiClient";
import { showError } from "~/utils/handleAPIError";
const props = defineProps<{
  formGuid: string;
  responseGuid: string;
}>();

const emit = defineEmits<{
  (e: "noteSaved", noteGuid: string): void;
  (e: "setUnsavedNote"): void;
}>();

const myInfoStore = useMyInfoStore();
const formResponse = ref<FormResponse>();
const form = ref<FormDefinition>();
const formText = ref<string>(JSON.stringify(form, null, 2));
const loading = ref<boolean>(true);

const displayMode = computed(
  () =>
    // formResponse.value?.status === FormResponseStatus.SUBMITTED
    //   ? FormDisplayMode.READ_ONLY
    //   : FormDisplayMode.EDIT,
    FormDisplayMode.READ_ONLY, // applications notes are legacy and wont be used anymore
);

onMounted(async () => {
  const res = await apiClient.formResponse
    .getFormResponse(
      myInfoStore.currentSysOrgGuid,
      props.formGuid,
      props.responseGuid,
    )
    .catch(showError);

  if (res) {
    loading.value = false;
    formResponse.value = res;
    form.value = res.formDefinition;
    formText.value = JSON.stringify(form.value, null, 2);
  }
});

watch(
  () => formResponse.value,
  (updated) => {
    if (updated?.status === FormResponseStatus.SUBMITTED) {
      emit("noteSaved", updated.guid);
    }
  },
  { deep: true },
);
</script>

<template>
  <div class="Note">
    <div v-loading="loading" class="formRenderer">
      <div v-if="form" class="formContainer">
        <FormRendererInner
          v-model="form"
          :form-response="formResponse"
          :display-mode="displayMode"
        >
          <template #default> </template>
        </FormRendererInner>
      </div>
    </div>
  </div>
</template>

<style lang="less">
.Note {
  .formRenderer {
    display: flex;
    flex-direction: column;
    gap: 1em;

    .RichTextComponent {
      .mce-content-body.mce-content-readonly {
        border: none;
      }
    }

    .formContainer {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;
      max-width: 1200px;

      .form {
        border: 0px;
        padding: 0;
        margin: 0;
        gap: 0;

        .tox-tinymce {
          border: 0px;
        }

        // undo the css used in the read only form view
        .mce-content-body {
          background: transparent;
          padding: 0;
          border-radius: 5px;
          margin-top: 0;
        }
      }
    }
  }
}
</style>
